module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-41.32feaca7.svg";